const contacts = '/contacts';
const companies = `${contacts}/companies`;
const keepInTouch = `${contacts}/keep-in-touch`;
const people = `${contacts}/people`;
const tags = `${contacts}/tags`;

export const ROUTES = {
	calendar: '/calendar',
	contacts: {
		main: contacts,
		companies,
		keepInTouch,
		people,
		tags,
	},
	dataBoards: {
		home: '/dataBoards',
		opportunities: '/dataBoards/opportunities',
		opportunitiesAdvancedReporting: '/dataBoards/opportunities/advancedReporting',
		donations: '/dataBoards/donations',
		donationsImport: '/dataBoards/donations/import',
		donationsAdvancedReporting: '/dataBoards/donations/advancedReporting',
		policies: '/dataBoards/policies',
		policiesAdvancedReporting: '/dataBoards/policies/advancedReporting',
		contactSelfImport: '/dataBoards/policies/contacts-self-import',
		matters: '/dataBoards/matters',
		mattersImport: '/dataBoards/matters/import',
		meetings: '/dataBoards/meetings',
		serviceJobs: '/dataBoards/serviceJobs',
		serviceJobsImport: '/dataBoards/serviceJobs/import',
	},
	emailExec: {
		briefs: '/email-exec/briefs',
	},
	reporting: {
		home: '/reporting',
		aiConversations: '/reporting/ai-conversations',
	},
	airesolver: '/airesolver',
} as const;
